import React from 'react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  return (
    <footer className="bg-dark-950 border-t border-dark-800 mt-auto">
      <div className="max-w-screen-lg mx-auto px-4 py-2">
        <div className="flex justify-center items-center space-x-4">
          <Link
            to="/privacy-policy"
            className="text-xs text-dark-400 hover:text-primary-400 transition-colors duration-200 font-mono"
          >
            Privacy
          </Link>
          <span className="text-dark-600">•</span>
          <Link
            to="/terms-of-service"
            className="text-xs text-dark-400 hover:text-primary-400 transition-colors duration-200 font-mono"
          >
            Terms
          </Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;